export default __webpack_public_path__ + "static/media/10.ba904347.png";